import axios from "axios";

import { baseURL } from "../commons/api_url";

axios.defaults.timeout = 1000 * 60 * 60 * 24 * 10;
axios.defaults.baseURL = baseURL;
// http request 拦截器

axios.interceptors.request.use(
    (config) => {
        const referrer = document.referrer || ''; // Fallback to '' if referrer is empty
        const json = {
            'Referrer-Embedding-Site': referrer // Custom header for embedding site
            // "Content-Type": "application/json",
        };
        // if (localStorage.getItem("token")) {
        //     json.Authorization = `Bearer ${localStorage.getItem("token")}`;
        // }
        config.headers = json;
        return config;
    },
    (error) => Promise.reject(error)
);

/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params,
        }).then((response) => {
            resolve(response?.data);
        })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * 封装POST 请求
 * @param url
 * @param data
 * @returns {Promise}
 */

const axiosFun = (url, data, type) => new Promise((resolve, reject) => {
    axios[type ?? "post"](url, data).then(
        (response) => {
            resolve(response?.data);
        },
        (error) => {
            // message.error(error?.response?.data?.msg ?? "")
            reject(error);
        }
    );
})
/**
 * 封装DELETE请求
 * @param url
 * @param data
 * @returns {Promise}
 */



/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}

// 统一接口处理，返回数据
// eslint-disable-next-line import/no-anonymous-default-export
const AxiosFetch = (type, url, param) => new Promise((resolve, reject) => {
    switch (type) {
        case "get":
            get(url, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
            break;
        case "post":
        case "put":
            axiosFun(url, param, type)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
            break;
        case "delete":
            axiosFun(url, param, type)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
            break;
        default:
            break;
    }
})

export default AxiosFetch
